import CloseIcon from '@mui/icons-material/Close';
import { Box, Fade, Modal, type SxProps, type Theme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { styles as style } from '@/components/StyledComponents';
import { Button } from '@/components/ui/button';
import { useLocationFrom } from '@/hooks/useLocationFrom';

interface Props {
    open: boolean;
    styles?: SxProps<Theme>;
    children: React.ReactNode;
    handleClose?: () => void;
    testId?: string;
    noClose?: boolean;
    onKeyDown?: (e: React.KeyboardEvent) => void;
}

export const ModalWindow = (props: Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = useLocationFrom();
    const { children, styles, open, handleClose, testId, noClose = false, onKeyDown } = props;

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            onKeyDown={onKeyDown}
        >
            <Fade in={open}>
                <Box sx={Object.assign(style.modalWindow, styles)}>
                    {children}
                    {!noClose && (
                        <Button
                            data-testid={testId}
                            variant="outlined"
                            onClick={() => {
                                if (handleClose) {
                                    return handleClose();
                                } else if (from) {
                                    return navigate(from + location.search);
                                }
                                navigate(-1);
                            }}
                            className="p-0 absolute top-[1.5em] right-[1.5em] z-[1200] [&_svg]:text-[1.3rem]"
                        >
                            <CloseIcon color="primary" fontSize="small" />
                        </Button>
                    )}
                </Box>
            </Fade>
        </Modal>
    );
};
